import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const TripsIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M6 2C4.895 2 4 2.895 4 4V20C4 21.105 4.895 22 6 22H16.0957L16.0605 21.9395L13.4316 20.3809C12.4486 19.7979 11.9047 18.7278 12.0137 17.5898C12.1217 16.4518 12.8566 15.5022 13.9316 15.1152L20 12.9297V4C20 2.895 19.105 2 18 2H6ZM23.0859 14C22.9829 14 22.8775 14.0186 22.7715 14.0566L14.6094 16.9961C13.8754 17.2611 13.7802 18.2612 14.4512 18.6602L17.5195 20.4805L19.3398 23.5488C19.5208 23.8538 19.8278 24 20.1328 24C20.4968 24 20.8599 23.7906 21.0039 23.3906L23.9434 15.2285C24.1674 14.6055 23.6859 14 23.0859 14ZM21.2812 16.7188L19.8945 20.5645L19.2402 19.4609L18.9805 19.0215L18.541 18.7617L17.4375 18.1055L21.2812 16.7188Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

TripsIcon.propTypes = {
  sx: PropTypes.object,
};

export default TripsIcon;
